import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ModuleService } from './core/services/module/module.service';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { PreferenceService } from './core/services/preference/preference.service';
import { ModuleVisibilityService } from './core/services/module-visibility/module-visibility.service';

/**
 * Data the signed-in app layout needs before it can render: instance
 * preferences (theme/branding), module visibility and the navigation tree.
 * Notifications are NOT loaded here — the bell component fetches its own
 * inbox when (and only where) it is mounted.
 */
@Injectable({
  providedIn: 'root',
})
export class InitialDataResolver {
  constructor(
    private _navigationService: NavigationService,
    private _preferenceService: PreferenceService,
    private _moduleVisibilityService: ModuleVisibilityService
  ) {}

  //================================================
  //? @PUBLIC METHODS
  //================================================

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return forkJoin([
      this._preferenceService.getPreferenceByInstance(),
      this._moduleVisibilityService.load(),
      this._navigationService.get(),
    ]);
  }
}

/**
 * Minimal resolver for routes that render outside the signed-in layout
 * (auth pages, /select-instance): only the instance preference is needed,
 * for theming/branding. Module visibility, navigation, notifications and
 * chat are pointless before an instance is selected.
 */
@Injectable({
  providedIn: 'root',
})
export class BrandingDataResolver {
  constructor(private _preferenceService: PreferenceService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this._preferenceService.getPreferenceByInstance();
  }
}

@Injectable({
  providedIn: 'root',
})
export class NavigationResolver {
  constructor(private _moduleServices: ModuleService) {}

  //================================================
  //? @PUBLIC METHODS
  //================================================

  /**
   * Use this resolver to resolve initial mock-api for the application
   *
   * @param route
   * @param state
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    // Fork join multiple API endpoint calls to wait all of them to finish
    return this._moduleServices.getModulesByUser(true);
  }
}
